export const SET_ADDON_DATA = "SET_ADDON_DATA";
export const CLEAR_ADDON_DATA = "CLEAR_ADDON_DATA";

export const SETADDONDATA = (data: any) => {
  return {
    type: SET_ADDON_DATA,
    payload: data,
  };
};
export const CLEARADDONDATA = (data: any) => {
  return {
    type: CLEAR_ADDON_DATA,
    payload: data,
  };
};

const initialState: object = {};

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ADDON_DATA:
        
      return {
        ...state,
        ...payload,
      };
    case CLEAR_ADDON_DATA:
      return {
        ...payload,
      };

    default:
      return state;
  }
};

export default reducer;
